import React, {Component} from 'react';
import axios from "axios";
import Select from "react-select";
import Button from "react-bootstrap/Button";

import classes from'./NewGroup.module.css';
import Form from "react-bootstrap/Form";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import apiUrl from "../../../shared/config";

class NewGroup extends Component  {
    state = {
        groups: [],
        group: {
            group_id: null,
            group_name: '',
            group_type_id: null,
            auto_join: 1,
            group_active: 1
        },
        group_types: [{
            group_type_id: null,
            group_type_name: ""
        }]
    };

    componentDidMount() {
        if (this.state.group_types !== []) {
            axios.get(apiUrl +'GroupTypes/getGroupTypes')
                .then(response => {
                    this.setState({group_types: response.data});
                });
        }

        if (this.props.groups !== []) {
            this.setState({groups: this.props.groups});
        }


    }

    addHandler = () => {
        this.postDataHandler(null);
        this.props.newGroupToggle();
    };

    postDataHandler = () => {
        const post = {
            "group_id": this.state.group.group_id,
            "group_name": this.state.group.group_name,
            "group_type_id": this.state.group.group_type_id,
            "group_active": 1,
            "auto_join": this.state.group.auto_join
        };
        axios.post(apiUrl +'Groups/set', post)
            .then(response => {
                this.props.onNewGroup(response.data);
            });
        this.setState({
            "group": {
                group_id: null,
                group_name: '',
                group_type_id: null,
                auto_join: 1,
                group_active: 1
            }
        });

    };

    arraySearch(arr,val) {
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].value === val)
                return i;
        }
        return -1;
    }

    render() {
        const groupTypeOptions = this.state.group_types
            .map( developer => ({value: developer.group_type_id, label: developer.group_type_name}));


        return (
                <dd className={"col-sm-12"}>
                    <div className={classes.NewGroupBlock}>
                        <div>
                            <Form.Control
                                type="text"
                                placeholder="Enter the name of the developer you want to create."
                                value={this.state.group.group_name}
                                onChange={(event) => this.setState({group: {...this.state.group, group_name: event.target.value}})}
                            />

                            <Select
                                defaultValue={{
                                    value: null,
                                    label:"What type of group is this?",
                                    isFixed: true,
                                    isDisabled: true
                                }}
                                options={groupTypeOptions}
                                closeMenuOnSelect={true}
                                onChange={(val) => {
                                    this.setState({group: {...this.state.group, group_type_id: val.value}});
                                }}
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={(!!this.state.group.auto_join)}
                                        onChange={(event) => this.setState({group: {...this.state.group, auto_join: (this.state.group.auto_join === 1 ? 0 : 1)}})}
                                        name="auto_join"
                                        color="primary"
                                    />
                                }
                                label="New members can join automatically."
                            />
                        </div>
                        <Button className="col-sm-3" variant="outline-warning" onClick={this.props.newGroupToggle}>Cancel</Button>
                        <Button className="col-sm-3" variant="outline-primary" onClick={
                            this.addHandler
                        }>Submit</Button>
                    </div>
                </dd>
        );
    }
}

export default NewGroup;